<template>
  <basic-card>
    <template slot="header">
      {{ displayName }}
    </template>
    <template v-if="loading">
      <loader/>
    </template>
    <template v-else>
      <div :style="{'font-size': '2em', 'color': cashflowResult.value < 0 ? '#C84E4F' : undefined}">
        {{ $formats.formatAmount(cashflowResult.value) }}
      </div>
      <div v-if="cashflowResult.diff != 0" :style="{'color': cashflowResult.diff < 0 ? '#C84E4F' : '#96f364'}">
        {{  cashflowResult.diff < 0 ? "↓" : "↑" }} &nbsp; {{ $formats.formatAmount(cashflowResult.diff) }}
      </div>
      <br/>
      <router-link :to="`/cash-flow/report/${cashflowReport}`">
        Go to report {{reportDefinition(cashflowReport).name}}
      </router-link>
    </template>

  </basic-card>
</template>

<script>
import {mapGetters} from "vuex";
import * as d3 from 'd3';
import BasicCard from "@/components/layout/BasicCard";
import Loader from "@/components/Loader";


export default {
  name: "SingleCashflowCellWidget",
  components: {Loader, BasicCard},
  props: {
    displayName: String,
    cashflowReport: String,
    cashflowDateFrom: String,
    cashflowDateTo: String,
    visualization: String,
    fromBalancePart: Boolean,
    path: String
  },
  computed: {
    ...mapGetters({
      report: 'cashflowReports/report',
      reportDefinition: 'cashflowReportDefinitions/cashflowReportDefinition'
    }),
    cashflowResult() {
      let diffDateFrom = (this.$moment(this.focusedDateFrom).diff(this.internalReport.startDate, "days"));
      let diffDateTo = (this.$moment(this.focusedDateTo).diff(this.internalReport.startDate, "days"));
      let root = this.fromBalancePart ? this.internalReport.balanceRoot : this.internalReport.root;
      let pathSegments = this.path.split(".");
      let pathSegmentsJoined = pathSegments.map(segment => `['${segment}']`).join(".children")

      let pathAdjusted = "children" + pathSegmentsJoined + ".cells";

      let valuesAtPath = this.$_.at(root, pathAdjusted)[0];
      if(valuesAtPath !== undefined) {
        /*
         *  {name: 'Show value at start date', id: "VALUE_AT_DATE_FROM"},
         {name: "Show value at end date with diff", id: "VALUE_AT_DATE_TO_DIFF" },
         {name: "Show values sum over period", id: "SUM_OVER_PERIOD"},
         {name: "Show values average over period", id: "AVG_OVER_PERIOD"},
         */
        const decimalPrecision = 100;
        let result = { value: 0, diff: 0}
        switch (this.visualization){
          case "VALUE_AT_DATE_FROM":
            result.value = valuesAtPath[diffDateFrom].totalValue / decimalPrecision
              break;
          case "VALUE_AT_DATE_TO_DIFF":
            result.value = valuesAtPath[diffDateTo].totalValue / decimalPrecision
            result.diff = result.value - (valuesAtPath[diffDateFrom].totalValue / decimalPrecision)
              break;
          case "SUM_OVER_PERIOD":
            result.value = valuesAtPath.slice(diffDateFrom, diffDateTo).reduce((prev, curr) => {
              return prev + curr.totalValue / decimalPrecision
            }, 0);
            break;
          case "AVG_OVER_PERIOD":
            const valuesSlice = valuesAtPath.slice(diffDateFrom, diffDateTo)
            result.value = valuesSlice.reduce((prev, curr) => {
              return prev + curr.totalValue / decimalPrecision
            }, 0) / valuesSlice.length;
            break;
        }

        return result;
      }
      else {
        return Number.NaN
      }
    }
  },
  data: function() {
      return {
        internalReport: {},
        loading: true,
        focusedDateFrom: "",
        focusedDateTo: ""
      }

  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("cashflowReports/reloadReport", {reportId: this.cashflowReport});
    this.focusedDateFrom = await this.convertRelativeDate(this.cashflowDateFrom)
    this.focusedDateTo = await this.convertRelativeDate(this.cashflowDateTo)
    this.internalReport = this.report(this.cashflowReport);
    this.loading = false;
  }
}
</script>

<style scoped>

</style>
